import { useEffect, useState } from "react";
import { ChildRefData } from "../remote/scan_data"
import { useNavigate } from "react-router-dom";
import { FQDN, FQDNSimple } from "./FQDN";
import { IP, IPSimple } from "./IP";
import { Port, PortSimple } from "./Port";
import { Technology, TechnologySimple } from "./Technology";
import { Certificate, CertificateSimple } from "./Certificate";
import { VulnerabilityInstance, VulnerabilityInstanceSimple } from "./Vulnerability";
import { WeaknessInstance, WeaknessInstanceSimple } from "./Weakness";
import { Box, Typography } from "@mui/material";

export class ScanChildrenProps {
	data: ChildRefData[]

	constructor(data: ChildRefData[]) {
		this.data = data;
	}
}

export const ScanChildren = (props: ScanChildrenProps) => {
	const navigate = useNavigate()

	const childCases = new Map([
		["FQDN", (id) => <FQDN id={id} data={undefined}/>],
		["IP", (id) => <IP id={id} data={undefined}/>],
		["PORT", (id) => <Port id={id} data={undefined}/>],
		["TECHNOLOGY", (id) => <Technology id={id} data={undefined}/>],
		["CERTIFICATE", (id) => <Certificate id={id} data={undefined}/>],
		["VULNERABILITY", (id) => <VulnerabilityInstance id={id} data={undefined}/>],
		["WEAKNESS", (id) => <WeaknessInstance id={id} data={undefined}/>],
	])

	return <>
		<Typography variant="h4">Children</Typography>
			{props.data.map((x) => {
				const func = childCases.get(x.type)
				if (func) {
					return (<>{func(x.id)}
					<Box margin='1em'></Box>
					</>)
				}
			})}</>
}
